import { createTransformer } from './shared/base-api';
import { getDashboardDataResponseSchema, } from '../../';
export const dashboardApiEndpoints = (builder, coreApiBaseUrl) => ({
    getDashboardData: builder.query({
        query: ({ projectId, packageId, reference }) => `${coreApiBaseUrl}/projects/${projectId}/packages/${packageId}/dashboard-summary/${reference ? `?reference=${encodeURIComponent(reference)}` : ''}`,
        transformResponse: createTransformer(getDashboardDataResponseSchema, 'GetDashboardData'),
        providesTags: ['DashboardData'],
    }),
});
